export default {
  noActiveJob: 'Nenašli sa žiadne aktívne úlohy',
  pinnedSensorModalHeader: 'Vyberte pripnuté senzory',
  pinnedSensorListHeadline: 'Pripnuté senzory',
  jobTableHeader: 'Bežiaca úloha vo vybranom časovom rozsahu',
};
